import React from "react";
import styled from "styled-components";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";
const Layout = styled.div`
  font-family: "Oswald", sans-serif;
  padding: 80px 0 45px 0;
  background: #f6f6f6;
  .text-wrap {
    /* text-align: justify; */
    display: flex;
    justify-content: center;
    padding: 4.5% 4%;
  }
  .text-wrap p {
    max-width: 800px;
    text-align: center;
    line-height: 30px;
    @media (max-width: 767px) {
      text-align: justify;
      font-size: 110%;
      line-height: 30px;
      font-weight: 200;
    }
  }
  .title {
    font-size: 30px;
    text-transform: uppercase;
    font-family: "Oswald" sans-serif;
  }
  .ask-wrap {
    display: grid;
    place-items: center;
  }
`;
function Propose() {
  return (
    <>
      <Layout>
        <div>
          <div className="ask-wrap">
            <div>
              <h3 className="title">How he asked</h3>
            </div>
            <div>
              <p>
                <HeartStyle>
                  <span className="white-line"></span>
                  <HeartFilled
                    style={{ fontSize: 19, zIndex: 20, color: "red" }}
                  />
                  <HeartFilled
                    style={{
                      fontSize: 19,
                      marginLeft: -5,
                      color: "white",
                    }}
                  />
                  <span className="white-line"></span>
                </HeartStyle>
              </p>
            </div>
          </div>
          <div className="text-wrap">
            <p>
              <b>will you marry me.</b> Lorem ipsum dolor sit amet, consectetur
              adipiscing elit. Fusce urna urna, imperdiet et purus ut, ultricies
              sollicitudin arcu. Cras placerat, arcu non faucibus suscipit, ex
              arcu consectetur enim, eu malesuada magna turpis sit amet mauris.
              Nullam nec leo at lorem interdum commodo. Etiam mollis massa in
              mauris lacinia porta. Pellentesque tristique, ante nec dictum
              mollis, felis ligula ullamcorper velit, ac auctor est ipsum
              vehicula ex. Donec eu blandit est, id gravida justo. Maecenas
              laoreet laoreet congue. Cras sit amet vestibulum ligula. Ut nec
              eros.
            </p>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default Propose;
